import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useLoaderData } from 'react-router-dom';
import Books from '../../Books/Books';
import BooksSummery from '../../Books/BooksSummery/BooksSummery';
import Loading from '../Share/Loading/Loading';

const Advertise = () => {

    const { data: books = [], isLoading, refetch } = useQuery({
        queryKey: ['books'],
        queryFn: async () => {
            const res = await fetch(`https://assignment-12-server-beige.vercel.app/advertises`)
            const data = await res.json();
            return data;
        }
    })

    if (isLoading) {
        return <Loading></Loading>
    }

    return (
        <div className='my-6'>
            <h1 className='text-4xl text-center mt-8 font-semibold text-primary'>ADVERTISE</h1>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-6 '>
                {
                    books.map(book => <BooksSummery book={book} key={book._id} refetch={refetch} ></BooksSummery>)
                }
            </div>

        </div>
    );
};

export default Advertise;